import * as React from "react";
import { addTransaction, getAllExpenseType } from "state/apis";
import {
    TextField,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    useTheme,
    IconButton,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { Close as CloseIcon } from "@mui/icons-material";
const PropertyExpense = ({ open, onClose, editData, editMode }) => {
    const theme = useTheme();
    const [data, setData] = React.useState([]);
    const [request, setRequest] = React.useState({
        chequeId: null,
        contractId: null,
        expenseType: null,
        amount: 0,
        date: "",
        billNumber: "",
        bankRefNumber: "",
        transactionType: "",
        remarks: "",
        type: "debit",
        propertyId: "",
        description: "",
    });

    React.useEffect(() => {
        const fetchData = async () => {
            if (editMode && editData) {
                try {
                    const res = await getAllExpenseType(10000, 0);
                    setData(res?.data);
                } catch (error) {
                    console.error("Error fetching data:", error);
                }
            } else {
                setData([]);
            }
        };
        setRequest((prevData) => ({
            ...prevData,
            propertyId: editData?.id,
        }));
        fetchData();
    }, [editData, editMode]);

    const handleExpenseChange = (newValue) => {
        setRequest((prevData) => ({
            ...prevData,
            expenseType: newValue ? newValue.id : null,
        }));
    };

    const handleDateChange = (date) => {
        const formattedDate = date.format("YYYY-MM-DD");
        setRequest((prevData) => ({
            ...prevData,
            date: date ? formattedDate : "",
        }));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setRequest((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };
    const handleSubmit = async () => {
        try {
            if (!request.expenseType) {
                return toast.error("Please select expense type");
            }
            const response = await addTransaction(request);
            toast.success(response.message);

            setRequest((prevData) => ({
                ...prevData,
                chequeId: null,
                contractId: null,
                expenseType: null,
                amount: 0,
                date: "",
                billNumber: "",
                bankRefNumber: "",
                transactionType: "",
                remarks: "",
                type: "debit",
                propertyId: editData?.id,
                description: "",
            }));
            onClose();
        } catch (error) {
            console.error("Error:", error);
            if (error.response) {
                toast.error(error.response.data.message);
            } else if (error.request) {
                toast.error("No response received from server.");
            } else {
                toast.error("An error occurred. Please try again.");
            }
        }
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth={"md"}>
            {/* <DialogTitle sx={{ textAlign: "center", fontWeight: "900", mb: "2px" }}>
                {editData?.propertyName}
            </DialogTitle> */}
            <DialogTitle
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    fontWeight: "bold",
                    marginLeft: "6px",
                }}
            >
                {editData?.propertyName}
                <IconButton onClick={onClose} sx={{ color: "inherit" }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={3} p={"5px"}>
                    <Grid item xs={6}>
                        <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            options={data}
                            getOptionLabel={(option) => option.name}
                            value={
                                request.expenseType
                                    ? data.find((val) => val.id === request.expenseType)
                                    : null
                            }
                            onChange={(event, newValue) => handleExpenseChange(newValue)}
                            isOptionEqualToValue={(option, value) => option === value}
                            renderOption={(props, option) => (
                                <li {...props} key={option.id}>
                                    {option.name}
                                </li>
                            )}
                            sx={{
                                width: "100%",
                                "& .MuiOutlinedInput-root": {
                                    "&.Mui-focused fieldset": {
                                        borderColor: "primary.main",
                                    },
                                },
                                "& .MuiInputLabel-root": {
                                    "&.Mui-focused": {
                                        color: "primary.main",
                                    },
                                },
                            }}
                            renderInput={(params) => (
                                <TextField {...params} fullWidth label="Select Expense" />
                            )}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <LocalizationProvider dateAdapter={AdapterDayjs} color="primary">
                            <DatePicker
                                label="Select transaction date"
                                name="date"
                                value={request.date ? dayjs(request.date) : null}
                                onChange={handleDateChange}
                                format="DD/MM/YYYY"
                                sx={{
                                    width: "100%",
                                    "& .MuiOutlinedInput-root": {
                                        "&.Mui-focused fieldset": {
                                            borderColor: "primary.main",
                                        },
                                    },
                                    "& .MuiInputLabel-root": {
                                        "&.Mui-focused": {
                                            color: "primary.main",
                                        },
                                    },
                                }}
                            />
                        </LocalizationProvider>
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            color="primary"
                            fullWidth
                            label="Bill Number"
                            name="billNumber"
                            value={request?.billNumber}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            fullWidth
                            color="primary"
                            label="Amount"
                            type="number"
                            name="amount"
                            value={request.amount}
                            InputLabelProps={{
                                sx: { marginBottom: 1 },
                            }}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            label="Description"
                            variant="outlined"
                            multiline
                            fullWidth
                            color="primary"
                            rows={4}
                            value={request?.description}
                            name="description"
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            label="Remark"
                            variant="outlined"
                            multiline
                            fullWidth
                            color="primary"
                            rows={4}
                            value={request?.remarks}
                            name="remarks"
                            onChange={handleChange}
                        />
                    </Grid>
                </Grid>
                <DialogActions
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: theme.spacing(2),
                    }}
                >
                    <Button
                        variant="contained"
                        onClick={handleSubmit}
                        sx={{
                            color: theme.palette.primary,
                            backgroundColor: theme.palette.primary[800],
                        }}
                    >
                        Save
                    </Button>
                    <Button
                        variant="contained"
                        // onClick={handleSubmit}
                        sx={{
                            color: theme.palette.primary.light,
                            backgroundColor: theme.palette.secondary[200],
                        }}
                    >
                        Print
                    </Button>
                </DialogActions>
            </DialogContent>
        </Dialog>
    );
};

export default PropertyExpense;
